var map = {
	"./en/base.json": "4d0c",
	"./en/clientStatus.json": "000a",
	"./en/countries.json": "7c61",
	"./en/currencies.json": "bdd5",
	"./en/staticData.json": "6d26",
	"./en/timezones.json": "0526",
	"./en/trading.json": "f4cf",
	"./fr/base.json": "00a1",
	"./fr/clientStatus.json": "b444",
	"./fr/staticData.json": "c87c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";